import { AxiosInstance } from './axios.core';
import { API_URL } from './api.base';

export const addLease = (id: string, params: any): Promise<any> => {
    return AxiosInstance.post(`${API_URL}/devices/${id}/leases`, {...params});
}
export const getLeaseList = (id: string, params: any): Promise<any> => {
    return AxiosInstance.get(`${API_URL}/devices/${id}/leases`, {params});
}
export const getLeaseDetail = (id: string, leaseId: string): Promise<any> => {
    return AxiosInstance.get(`${API_URL}/devices/${id}/leases/${leaseId}`);
}
export const deleteLease = (id: string, leaseId: string): Promise<any> => {
    return AxiosInstance.delete(`${API_URL}/devices/${id}/leases/${leaseId}`);
}
export const sendLeaseSMS = (id: string, leaseId: string): Promise<any> => {
    return AxiosInstance.post(`${API_URL}/devices/${id}/leases/${leaseId}/sms`);
}
